import React from "react";
import { Text, withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { getRenderingParameters } from "@clarion/foundation/dist/Utils/sitecoreUtils";
import withFieldsCheck from "@clarion/foundation/dist/Helpers/containers/WithFieldsCheck/index";
import RichTextPanel from "@clarion/foundation/dist/Helpers/components/RichTextPanel";
import { formatDate } from "@clarion/foundation/dist/Utils/formatingUtils";
import "./index.css";
const ArticleHeader = ({
  sitecoreContext,
  params
}) => {
  const routeFields = sitecoreContext.route.fields;
  const decorationColour = getRenderingParameters(params, "DecorationColour");
  const fields = sitecoreContext.route.fields;
  const publishedOn = fields.PublishedOn?.value ? formatDate(fields.PublishedOn.value) : null;
  const tag = fields.Tags[0]?.fields.Value.value;
  const mandatoryFields = tag && fields.Title.value && publishedOn;
  return /*#__PURE__*/React.createElement(React.Fragment, null, mandatoryFields && /*#__PURE__*/React.createElement("div", {
    className: "article-header bg bg--cream"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article-header__eyebrow"
  }, /*#__PURE__*/React.createElement("span", null, tag), /*#__PURE__*/React.createElement("span", null, publishedOn)), /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    className: `article-header__title ${decorationColour ? "article-header__title--" + decorationColour : ""}`,
    field: fields.Title
  }), /*#__PURE__*/React.createElement(RichTextPanel, {
    className: "article-header__desc",
    text: routeFields.Description
  }))));
};
const ArticleHeaderWithFieldsCheck = withFieldsCheck(ArticleHeader, {
  routeField: "PublishedOn"
});
export default withSitecoreContext()(ArticleHeaderWithFieldsCheck);